import { FinancialApi } from './financialApi';

const financialApi = new FinancialApi();

export { financialApi };
